<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <template v-slot:activator="{ on, attrs }">
      <v-btn color="primary" dark v-bind="attrs" v-on="on" @click="equal">
        {{ $t('title_cus_edit') }}
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <span class="headline">{{ $t('cap_cus_edit') }}</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="CustomerAddress"
                label="Location*"
                prepend-icon="mdi-map-marker"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="CustomerNote"
                label="Note*"
                prepend-icon="mdi-square-edit-outline"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="dialog = false">
          {{ $t('btn_cap_close') }}
        </v-btn>
        <v-btn color="blue darken-1" text @click="updateCustomer">
          {{ $t('btn_cap_save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'CassEditCustomerInfo',
  props: {
    documentId: {
      type: String,
      default: 'EhE7o1faLNMEu0GOPevu'
    }
  },
  data() {
    return {
      dialog: false,
      CustomerAddress: null,
      CustomerNote: null
    }
  },
  computed: {
    orderDetail() {
      if (this.documentId) {
        return this.$store.getters['order/orderAfterFilter'].filter(
          (order) => order.documentId === this.documentId
        )[0]
      } else {
        return this.$store.state.order.sample[0]
      }
    },
    noteRules() {
      return [(v) => !!v || 'Note is required']
    },
    locationRules() {
      return [(v) => !!v || 'Location is required']
    }
  },
  methods: {
    updateCustomer() {
      this.dialog = false
      const customerEdition = {
        documentId: this.documentId,
        address: this.CustomerAddress,
        note: this.CustomerNote
      }
      this.$store
        .dispatch('order/editCustomer', customerEdition)
        .then(() => {
          console.log('success')
        })
        .catch(() => {
          console.log('Error')
        })
    },
    equal() {
      this.CustomerAddress = this.orderDetail.customer.location.address
      this.CustomerNote = this.orderDetail.customer.note
    }
  }
}
</script>

<style scoped></style>
